export default "__VITE_ASSET__BdaYnDfM__"